export const enum EAuthStatus {
  UNAUTHORIZED = 'UNAUTHORIZED',
  AUTHORIZED = 'AUTHORIZED',
  PENDING = 'PENDING'
}
